import { type FormatNumberOptions, FormattedNumber } from 'react-intl';

const MS_PER_MIN = 60 * 1000;

const HOUR_IN_MINS = 60;
const TWELVE_HOURS_IN_MINS = 12 * HOUR_IN_MINS;

const baseIntlProps = {
    style: 'unit',
    unitDisplay: 'short',
    unit: 'hour',
    signDisplay: 'exceptZero',
} satisfies FormatNumberOptions;

export const timeDifference = (diffInMs: number) => {
    const diffInMinutes = Math.floor(diffInMs / MS_PER_MIN);

    // Delta more than 12 hours
    if (Math.abs(diffInMinutes) >= TWELVE_HOURS_IN_MINS) {
        return (
            <>
                {'> '}
                <FormattedNumber
                    {...baseIntlProps}
                    value={Math.sign(diffInMinutes) * 12}
                    style={'unit'}
                    signDisplay={'negative'}
                />
            </>
        );
    }

    // Delta more than 1 hour
    if (Math.abs(diffInMinutes) >= HOUR_IN_MINS) {
        return <FormattedNumber {...baseIntlProps} value={Math.floor(diffInMinutes / 60)} />;
    }

    // Delta less than 1 hour
    return <FormattedNumber {...baseIntlProps} value={Math.floor(diffInMinutes)} unit='minute' />;
};

export const TimeDifference = ({ expected, actual }: { expected: string; actual: string | undefined }) => {
    if (!actual) {
        return null;
    }
    const diffInMs = new Date(actual).getTime() - new Date(expected).getTime();
    if (Number.isNaN(diffInMs)) {
        return null;
    }

    const color = diffInMs > 0 ? 'text-color-danger' : 'text-color-success';
    return <span className={`${color} padding-left-5 text-size-10`}>{timeDifference(diffInMs)}</span>;
};
